import './assets/main.css';

import { createPinia } from 'pinia';
import { createApp } from 'vue';

import { PerfectScrollbarPlugin } from 'vue3-perfect-scrollbar';
import 'vue3-perfect-scrollbar/style.css';
import App from './App.vue';
import router from './router';

declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Kakao: any;
  }
}

const app = createApp(App)

app.use(createPinia())
app.use(router)
app.use(PerfectScrollbarPlugin)
app.mount('#app')

window.Kakao.init(import.meta.env.VITE_KAKAO_JAVASCRIPT_KEY)